import React from 'react';
import { globalTranslationKeys } from '../../../enums';

const GameResultPopUp = ({ finishedOdd, t }) => {
  return (
    <div className={`odb-popup-inner`}>
      <p className='pop-result-txt'>{t(globalTranslationKeys.GameResult)}</p>
      <p className='pop-result-money'>x{finishedOdd}</p>
    </div>
  );
};

export default GameResultPopUp;
